import { useEffect, useRef, useState, type MouseEvent } from 'react';
import importScreen from '../../assets/landing/record-import-real.jpg';
import bulkScreen from '../../assets/landing/bulk-data-real.jpg';
import solutionScreen from '../../assets/landing/solution-builder-real.jpg';
import '../../styles/RealToolShowcase.scss';

const screens = [
    { name: 'Importa dati', tool: 'CSV & Excel Record Import', image: importScreen, description: 'Collega le colonne del file ai campi Dataverse e controlla l’anteprima prima di scrivere.' },
    { name: 'Lavora in serie', tool: 'Bulk Data Operations', image: bulkScreen, description: 'Scegli i record e l’operazione da eseguire. La schermata mostra la selezione dei dati demo.' },
    { name: 'Costruisci', tool: 'Solution Builder', image: solutionScreen, description: 'Trova i componenti e componi una soluzione. Qui è aperta una solution dell’ambiente demo.' },
];

type Props = { selected?: number; onSelect?: (index: number) => void };

/** Real tool screens. The page can drive the selected tab (the comic does); without props it manages its own. */
export default function RealToolShowcase({ selected: selectedProp, onSelect }: Props) {
    const [ownSelected, setOwnSelected] = useState(0);
    const [expanded, setExpanded] = useState(false);
    const dialog = useRef<HTMLDialogElement>(null);
    const opener = useRef<HTMLElement | null>(null);
    const selected = selectedProp ?? ownSelected;
    const screen = screens[selected];

    const choose = (index: number) => { setOwnSelected(index); onSelect?.(index); };
    const open = (event: MouseEvent<HTMLElement>) => { opener.current = event.currentTarget; setExpanded(true); };

    useEffect(() => {
        const element = dialog.current;
        if (!element) return;
        if (expanded && !element.open) element.showModal();
        if (!expanded && element.open) element.close();
    }, [expanded]);

    // The native dialog traps focus and closes on Escape; focus goes back to the button that opened it.
    const handleClose = () => { setExpanded(false); opener.current?.focus(); };

    return <section className="sp-real-tools" aria-label="Schermate reali dei tool Semplora">
        <div className="sp-real-tools__tabs" role="group" aria-label="Scegli un tool da vedere">
            {screens.map((item, index) => <button key={item.tool} type="button" aria-pressed={selected === index} onClick={() => choose(index)}><span>0{index + 1}</span>{item.name}</button>)}
        </div>
        <div className="sp-real-tools__frame">
            <div className="sp-real-tools__bar"><span aria-hidden="true">● ● ●</span><strong>{screen.tool}</strong><span>DEMO</span></div>
            <button type="button" className="sp-real-tools__image" onClick={open} aria-label={`Ingrandisci la schermata di ${screen.tool}`}><img key={screen.tool} src={screen.image} alt={`Interfaccia reale di ${screen.tool} con dati dimostrativi`} loading="lazy" /></button>
        </div>
        <div className="sp-real-tools__caption"><p>{screen.description}</p><button type="button" onClick={open}>Ingrandisci ↗</button></div>
        <span className="sp-real-tools__note">Catture delle interfacce di Semplora · dati dimostrativi</span>
        <dialog ref={dialog} className="sp-real-tools__lightbox" aria-label={`Schermata di ${screen.tool}`} onClose={handleClose} onClick={event => { if (event.target === event.currentTarget) setExpanded(false); }}>
            {expanded && <div>
                <button type="button" onClick={() => setExpanded(false)} aria-label="Chiudi immagine ingrandita">×</button>
                <img src={screen.image} alt={`Interfaccia reale di ${screen.tool} con dati dimostrativi`} />
                <p>{screen.tool} · dati dimostrativi</p>
            </div>}
        </dialog>
    </section>;
}
